"use client";
import Marquee from "react-fast-marquee";
import type { Notice } from "@/lib/types";

export function NoticeContent({ notice }: { notice: Notice[] }) {
  return (
    <Marquee>
      {notice.map((item) => (
        <span key={item.id} className="mr-[50dvw]">
          {item.content}
        </span>
      ))}
    </Marquee>
  );
}
